import React from "react";
import "./AboutUsComponent.css";

const AboutUsComponent = () => {
  return (
    <section className="about-us">
      <span className="about-label">About Nobel AI Legal</span>
      <h2>
        Revolutionizing Legal Services with <br /> AI
      </h2>
      <p>
        Founded in 2025, Nobel AI Legal is transforming how Personal Injury
        Lawyers handle Accident Benefits and TORT Claims. Our AI-driven platform
        eliminates outdated methods like emails and faxes, enabling real-time
        data sharing for faster case resolutions, improved accuracy, and better
        client outcomes.
      </p>
    </section>
  );
};

export default AboutUsComponent;
